import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class BranchTaxCreditableAddService {

  constructor(private http: HttpClient) { }

  saveBranchTaxCreditableForm(
    baseUrl: string,
    returnClobSettingsObj: any,
    defaultsChangeDetails: any[],
    globalService: any,
    filterParams: any = {},
    selectedEntity: any = {}
  ): Observable<any> {
    // Use correct endpoint and action code (matching AngularJS BranchTaxFactory.savePivotedData)
    // Handle baseUrl with or without trailing slash
    const baseUrlClean = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
    const url = `${baseUrlClean}/saveJsonAsPivotObject?action_code=brk8nt`;

    // Build payload exactly like AngularJS BranchTaxFactory.savePivotedData
    // clob_settings should only contain scenario and object_id (matching AngularJS pattern)
    const clobSettings = {
      scenario: returnClobSettingsObj.scenario,
      object_id: returnClobSettingsObj.object_id
    };

    let params = _.merge({}, globalService?.globalParams || {}, filterParams);
    params = _.extend({ clob_data: JSON.stringify(defaultsChangeDetails) }, params);
    params = _.extend({ clob_settings: JSON.stringify(clobSettings) }, params);
    
    // Build checkLockedbj from selectedEntity (for ADD mode)
    const checkLockedbj = [{
      "leid": selectedEntity.HO_LEID || selectedEntity.LEID || '',
      "me_code": selectedEntity.ME_CODE || '',
      "cdr_number": selectedEntity.HO_CDR_NO || selectedEntity.CDR_NO || selectedEntity.MARS || '',
      "reporting_period": selectedEntity.HO_REPORTING_PERIOD || selectedEntity.REPORTING_PERIOD || '',
      "combination_key": returnClobSettingsObj.object_id || selectedEntity.KEY || selectedEntity.COMBINATION_KEY || '',
      "scenario_key": parseInt(returnClobSettingsObj.scenario || filterParams.scenario || "1")
    }];
    params.checkLockedbj = JSON.stringify(checkLockedbj);

    // Ensure required parameters are set
    if (!params.tax_year) {
      params.tax_year = filterParams.tax_year || returnClobSettingsObj?.tax_year || globalService?.globalParams?.tax_year || globalService?.tax_year || '';
    }
    if (!params.scenario) {
      params.scenario = filterParams.scenario || returnClobSettingsObj?.scenario || globalService?.globalParams?.scenario || globalService?.scenario || '';
    }
    if (!params.jcd_key) {
      params.jcd_key = filterParams.jcd_key || returnClobSettingsObj?.jcd_key || globalService?.globalParams?.jcd_key || globalService?.jcd_key || 250;
    }
    if (params.scenarioCode === undefined || params.scenarioCode === null || params.scenarioCode === '') {
      params.scenarioCode = params.scenario_code || filterParams.scenarioCode || filterParams.scenario_code || returnClobSettingsObj?.scenarioCode || returnClobSettingsObj?.scenario_code || globalService?.globalParams?.scenarioCode || globalService?.scenarioCode || 'RAF';
      if (params.scenario_code) delete params.scenario_code;
    }
    if (params.is_issue_key_enabled === undefined || params.is_issue_key_enabled === null || params.is_issue_key_enabled === '') {
      params.is_issue_key_enabled = filterParams.is_issue_key_enabled || returnClobSettingsObj?.is_issue_key_enabled || globalService?.globalParams?.is_issue_key_enabled || globalService?.is_issue_key_enabled || 'N';
    }

    // Convert to URLSearchParams for form-urlencoded format (matching AngularJS transformRequest behavior)
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      const value = params[key];
      if (value !== undefined && value !== null) {
        urlEncoded.set(key, value.toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }

  getCodeCombinationData(
    baseUrl: string,
    taxYear: any,
    scenario: any,
    globalService: any
  ): Observable<any> {
    const params: any = {
      "action_code": 'g1mvvs',
      "p_tax_year": taxYear,
      "p_scenario": scenario
    };

    // Handle baseUrl with or without trailing slash
    const baseUrlClean = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
    const url = `${baseUrlClean}/loadJsonObject`;

    // Convert to URLSearchParams for form-urlencoded format
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }

  getGeneratedLeidDropDown(
    baseUrl: string,
    scenario: any,
    hoLeid: string,
    hoCdrNo: string,
    hoReportingPd: string,
    globalService: any
  ): Observable<any> {
    const params: any = {
      "action_code": 'yxpce4',
      "scenario": scenario,
      "ho_leid": hoLeid,
      "ho_cdr_no": hoCdrNo,
      "ho_reporting_pd": hoReportingPd
    };

    // Handle baseUrl with or without trailing slash
    const baseUrlClean = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
    const url = `${baseUrlClean}/loadJsonObject`;

    // Convert to URLSearchParams for form-urlencoded format
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }
}
